<template>   
    <div style="width: 100%; min-height: 100dvh; margin-left: 30px; margin-right: 30px;">


        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                <VueSkeletonLoader
                type="rect"
                wave-color="#c5d4e7"
                color="#c5d4e7"
                    class="skeleton-full"
                animation="fade"
                />
            </div>  

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                <VueSkeletonLoader
                type="rect"
                wave-color="#c5d4e7"
                color="#c5d4e7"
                    class="skeleton-full"
                animation="fade"
                />
            </div> 

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                <VueSkeletonLoader
                type="rect"
                wave-color="#c5d4e7"
                color="#c5d4e7"
                    class="skeleton-full"
                animation="fade"
                />
            </div> 
        </div>

        <div class="row">

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8" style="margin-top: 10px;">
                <VueSkeletonLoader
                type="rect"
                wave-color="#c5d4e7"
                color="#c5d4e7"
                    class="skeleton-full2"
                animation="fade"
                />
            </div> 

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4" style="margin-top: 10px;">
                <VueSkeletonLoader
                type="rect"
                wave-color="#c5d4e7"
                color="#c5d4e7"
                    class="skeleton-full2"
                animation="fade"
                />
            </div> 
        </div>
        <!-- <div class="container mt-5">
            <VueSkeletonLoader
                type="rect"
                wave-color="#A9A9A9"
                color="#A9A9A9"
                class="skeleton-full2"
                animation="fade"
            />
        </div>
        <div class="container mt-5">
            <VueSkeletonLoader
                type="rect"
                wave-color="#A9A9A9"
                color="#A9A9A9"
                class="skeleton-full"
                animation="fade"
            />
        </div> -->
    </div>
   </template>
   <script>
   import VueSkeletonLoader from 'skeleton-loader-vue';
   export default {
     components: { VueSkeletonLoader },
   };
   
   </script>
   <style>
   .skeleton-full {
      width: 100% !important; /* Ou outro valor adequado */
      height: 200px !important;
      border-radius: 20px !important;
    }
    .skeleton-full2 {
      width: 100% !important; /* Ou outro valor adequado */
      height: 450px !important;
      border-radius: 20px !important;
    }
   </style>